








































import PuzzleForTeacher from './PuzzleForTeacher.vue'
import PuzzleForStudent from './PuzzleForStudent.vue'
import ConfigPuzzleImg from './ConfigPuzzleImg.vue'
import ModalDelete from '../../Modal/Delete.vue'
import ModalTraining from '../../Modal/TrainingVideo.vue'
import ModalCopyHomework from '@/containers/Modals/CopyHomework.vue'
import { Vue, Component } from 'vue-property-decorator'
import { DateTime } from 'luxon'
import Loader from '@/components/Loader.vue'
import { getTime } from '@/helpers/getTime'

const monthList = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
]

@Component({
	components: {
		PuzzleForTeacher,
		PuzzleForStudent,
		ConfigPuzzleImg,
		ModalDelete,
		ModalTraining,
		ModalCopyHomework,
		Loader,
	},
})
export default class HomeworkCalendar extends Vue {
	slide = JSON.parse(localStorage.getItem('userProfile') as any)?.is_free
		? 1
		: localStorage.getItem('slide')
			? JSON.parse(localStorage.getItem('slide') ?? 'false')
			: 1
	year = this.currentYear
	month = this.currentMonth
	homeworks: any[] = []
	// showModalTraining = !localStorage.getItem('dontShowTraining')
	showModalDelete = false
	showModalCopyHomework = false as any
	showModalPuzzleSuccess = false
	loading = true
	role =
		window.localStorage.getItem('userProfile') === null
			? null
			: JSON.parse(window.localStorage.getItem('userProfile') as any).role
	firstPage = 1

	beforeMount() {
		// if (!localStorage.getItem('slide'))

		this.updateHomeworkList()
	}

	mounted() {
		console.log(this.role)
	}

	openModalCopy({ id, order, slide }: any) {
		const daysDone = this.puzzles
			.filter(p => p.homework)
			.map(p => p.homework.order)
		this.showModalCopyHomework = { id, order, daysDone, slide }
	}

	openModalDelete(id: any) {
		this.$store.commit('changeModalId', [id])
		this.showModalDelete = true
	}

	openModal(id: string) {
		this.$store.commit('changeModalId', [id])
		this.showModalDelete = true
	}

	deleteHomework() {
		if (this.$route.name === 'Profile Homework') {
			this.axios({
				method: 'post',
				url: `lessons/homeworks/${this.$store.state.modalId[0]}/close_for_users`,
				data: {
					users: [this.$route.params.id],
				},
			}).then(resp => {
				this.updateHomeworkList()
				this.showModalDelete = false
			})
		} else {
			this.axios({
				method: 'post',
				url: `lessons/homeworks/${this.$store.state.modalId[0]}/close_for_groups`,
				data: {
					groups: [this.$route.params.id],
				},
			}).then(resp => {
				this.updateHomeworkList()
				this.showModalDelete = false
			})
		}
	}

	// changeMonth(step: number) {
	// 	let newSlide = this.slide + step

	// 	if (newSlide != 0 && newSlide != 49) {
	// 		const target = getTime(null, this.year, this.month + step, 1)

	// 		this.year = target.year
	// 		this.month = target.month

	// 		this.slide = newSlide

	// 		localStorage.setItem('slide', newSlide.toString())

	// 		this.updateHomeworkList()
	// 	}
	// }

	changeSlidesList(value: number) {
		const result = this.firstPage + value

		if (result < 64) {
			this.firstPage = result > 1 ? result : 1
		}
	}

	changeMonthByPage(step: number) {
		let newSlide = step

		if (newSlide != 0 && newSlide != 65) {
			const target = getTime(null, this.getCurrentYear(newSlide), this.getCurrentMonth(newSlide), 1)

			this.year = target.year
			this.month = target.month

			this.slide = newSlide

			localStorage.setItem('slide', newSlide.toString())

			this.updateHomeworkList()
		}
	}

	onSuccessCopy() {
		this.updateHomeworkList()
		this.showModalCopyHomework = false
	}

	updateHomeworkList() {
		this.loading = true
		let url = 'lessons/homeworks'
		if (this.$route.name === 'Group Homework') {
			url = `${url}?group=${this.$route.params.id}`
		} else if (this.$route.name === 'Profile Homework') {
			url = `${url}?user=${this.$route.params.id}`
		} else if (this.$route.query.read_only !== undefined) {
			url = `${url}?user=${this.$route.query.read_only}`
		} else if (this.$store.state.myProfile.role === 'student') {
			url = `${url}?user=${this.$store.state.myProfile.id}`
		}
		this.axios({
			method: 'get',
			url: url + `&month=${this.month - 1}&year=${this.year}`,
		}).then(resp => {
			this.homeworks = resp.data
			this.homeworks.forEach((homework: any) => {
				homework.tasks = 0
				if (homework.games)
					homework.games.forEach((game: any) => {
						if (game.data)
							game.data.forEach((data: any) => {
								if (!data.is_right_answer) {
									homework.tasks++
								}
							})
						else homework.tasks += game.tasks
					})
			})
			this.loading = false
		})
	}

	monthInText(monthNumber: number) {
		return monthList[monthNumber]
	}

	getCurrentYear(newSlide: number) {
		let slideAmount = newSlide
		let result = 2022

		while (slideAmount > 12) {
			slideAmount -= 12
			result += 1
		}

		return result
	}

	getCurrentMonth(newSlide: number) {
		let slideAmount = newSlide

		while (slideAmount > 12) {
			slideAmount -= 12
		}

		return slideAmount
	}

	get dayNames() {
		return window.screen.width < 1024
			? ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
			: [
				'Sunday',
				'Monday',
				'Tuesday',
				'Wensday',
				'Thusday',
				'Friday',
				'Saturday',
			]
	}

	get isStudentPage() {
		return this.$route.name === 'Dashboard Student Homework'
	}

	get copyHomeworkProps() {
		return {
			group_id:
				this.$route.name === 'Group Homework'
					? this.$route.params.id
					: undefined,
			user_id:
				this.$route.name === 'Profile Homework'
					? this.$route.params.id
					: undefined,
		}
	}

	get days() {
		type Day = {
			class?: 'disabled' | ''
			date: DateTime
			formattedDate: string
			homework?: any
			order?: number
			slide?: number
		}
		const calendar: Day[] = []
		const getDay = (date: DateTime) => {
			return {
				date,
				formattedDate: date.toISODate(),
			} as const
		}
		// const slide = localStorage.getItem('slide')

		const month = this.month //!!slide && !isNaN(+slide) ? JSON.parse(slide) : this.month

		const firstDayInMonth = DateTime.local(this.year, month, 1, 0, 0, 0, 0)

		const daysInCurrentMonth = 20

		calendar.push({
			...getDay(firstDayInMonth),
			order: 1,
			slide: this.slide, //firstDayInMonth.month,
		})

		// DAYS IN CURRENT MONTH
		for (let i = 1; i < daysInCurrentMonth; i++) {
			calendar.push({
				...getDay(firstDayInMonth.plus({ days: i })),
				order: i + 1,
			})
		}
		this.homeworks.forEach(homework => {
			for (const [index, day] of calendar.entries()) {
				if (index + 1 === homework.order) {
					day.homework = homework
				}
			}
		})
		return calendar
	}

	get puzzles() {
		let puzzles = []
		for (let day of this.days) {
			puzzles.push(day)
		}
		return puzzles
	}

	get isStudentHomework() {
		return this.$route.path === '/dashboard-student/homework'
	}

	get currentYear() {
		let slideAmount = this.slide
		let result = 2022

		while (slideAmount > 12) {
			slideAmount -= 12
			result += 1
		}

		return result
	}

	get currentMonth() {
		let slideAmount = this.slide

		while (slideAmount > 12) {
			slideAmount -= 12
		}

		return slideAmount
	}

	get pagesArray() {
		const pagesArray = [this.firstPage]

		for (let index = 0; index < 11; index++) {
			const nextSlide = pagesArray[pagesArray.length - 1] + 1

			if (nextSlide > 64) break;

			pagesArray.push(nextSlide)
		}

		return pagesArray
	}
}
